import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";

// MUI
import Button from "@mui/material/Button";

// Components
import Badge from "./Badge";
import { ALLOWED_MIME_TYPES } from "../../../../components/AttachMaterials";

// Styles
import styles from "./subunit.module.scss";

const SubUnitRow = ({ subunit, index, isLast, isLocked }) => {
  const { t } = useTranslation();

  // Ref
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    // TODO: Keith/Dmytro/Alex -> Implement file upload to a subunit
  };

  const handlePractice = () => {
  };

  const handleUploadMaterial = () => {
    // Click the hidden input to open the file picker
    fileInputRef.current.click();
  };

  if (!subunit) return null;
  const { title, familiarity } = subunit;

  return (
    <div className={`${styles.container} flex flex-row justify-between gap-4 items-stretch`}>
      {/** icon and familiarity */}
      <div className={`${styles.badgeContainer}`}>
        <Badge familiarity={familiarity} index={index} isLocked={isLocked} />

        {!isLast && <div className={`${styles.line} border-2 border-gray-200`} />}
      </div>

      {/** name and Points */}
      <div className="flex flex-1 flex-col">
        <h1 className="text-xl">{title}</h1>

      </div>

      {/** Actions */}
      <div className="flex flex-col items-end justify-center">
        <Button
          className="border-none"
          onClick={handlePractice}
          variant="text"
          color="primary"
          disabled={isLocked}
        >
          {t('masteryMap.actions.practice')}
        </Button>

        <Button
          className="border-none"
          onClick={handleUploadMaterial}
          variant="text"
          color="primary"
          disabled={isLocked}
          startIcon={<FiDownload />}
        >
          {t('masteryMap.actions.upload_material')}
        </Button>
      </div>

      <input
        type="file"
        hidden
        ref={fileInputRef}
        accept={ALLOWED_MIME_TYPES.join(',')}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
    </div>
  );
};

export default SubUnitRow;
